export const ONTARIO_LOCATION = {
  lat: 43.65413,
  lng: -79.39242,
};

export const QUEBEC_LOCATION = {
  lat: 45.567137,
  lng: -73.730618,
};

export const BRANCH_LOCATOR_RADIUS = 50; // in km

export const CUSTOMER_SUPPORT = {
  autoloans: 'autoLoans',
  general: 'general',
  salesAndApplication: 'salesAndApplication',
};

export const PROVINCES_LIST = [
  {
    name: 'Alberta',
    code: 'AB',
    coordinates: {
      lat: 49.7275963,
      lng: -112.7968189,
    },
  },
  {
    name: 'British Columbia',
    code: 'BC',
    coordinates: {
      lat: 49.5173248,
      lng: -115.7540098,
    },
  },
  {
    name: 'Manitoba',
    code: 'MB',
    coordinates: {
      lat: 49.9587902,
      lng: -97.0898835,
    },
  },
  {
    name: 'New Brunswick',
    code: 'NB',
    coordinates: {
      lat: 45.2568157,
      lng: -66.1017538,
    },
  },
  {
    name: 'Newfoundland and Labrador',
    code: 'NL',
    coordinates: {
      lat: 48.1644316,
      lng: -53.980836,
    },
  },
  {
    name: 'Nova Scotia',
    code: 'NS',
    coordinates: {
      lat: 43.8413949,
      lng: -66.0957226,
    },
  },
  {
    name: 'Ontario',
    code: 'ON',
    coordinates: {
      lat: 44.1018128,
      lng: -77.5756806,
    },
  },
  {
    name: 'Prince Edward Island',
    code: 'PE',
    coordinates: {
      lat: 46.2418376,
      lng: -63.1347011,
    },
  },
  {
    name: 'Quebec',
    code: 'QC',
    coordinates: {
      lat: 45.567137,
      lng: -73.730618,
    },
  },
  {
    name: 'Saskatchewan',
    code: 'SK',
    coordinates: {
      lat: 52.11537,
      lng: -106.611924,
    },
  },
];

export const LANGUAGE_KEY_EN = 'en-CA';
export const LANGUAGE_KEY_FR = 'fr-CA';
export const LANGUAGE_KEY_EN_QC = 'en';
export const LANGUAGE_KEY_FR_QC = 'fr';
export const IS_QC_REGION_KEY = 'QC';
export const ROC_DEFAULT_PROVINCE_CODE = 'ON';
export const QC_DEFAULT_PROVINCE_CODE = 'QC';
export const WEEKDAY_TIMING = '8am - 8pm EST';
export const WEEKEND_TIMING = '10am - 6:30pm EST';
export const CHAT_BUTTON_TEXT_EN = 'Live Chat';
export const CHAT_BUTTON_OFFLINE_EN = 'Agent Offline';
export const CHAT_LOADING_EN = 'Loading';
export const CHAT_BUTTON_TEXT_FR = 'Chat en direct';
export const CHAT_BUTTON_OFFLINE_FR = 'Agent hors ligne';
export const CHAT_LOADING_FR = 'Chargement';
export const CONTENT_ALIGNMENT_LEFT = 'left';
export const CONTENT_ALIGNMENT_RIGHT = 'right';
export const { GATSBY_CONTENTFUL_PREVIEW_API } = process.env;
export const CONTAINER_NAMES = {
  FAQ_CONTAINER: 'FAQ_CONTAINER',
  HERO_BANNER_VARIATION: 'HERO_BANNER_VARIATION',
  HERO_BANNER_CAROUSEL_CONTAINER_VARIATION:
    'HERO_BANNER_CAROUSEL_CONTAINER_VARIATION',
  HERO_BANNER_CLAIMS_CONTAINER: 'HERO_BANNER_CLAIMS_CONTAINER',
  PERSONAL_LOAN_BENEFITS_CONTAINER: 'PERSONAL_LOAN_BENEFITS_CONTAINER',
  VALUE_PROPOSITION_PERSONAL_LOANS_CONTAINER:
    'VALUE_PROPOSITION_PERSONAL_LOANS_CONTAINER',
  PAYMENT_CALCULATOR_CONTAINER: 'PAYMENT_CALCULATOR_CONTAINER',
  CREDIT_OPTIMIZER_CONTAINER: 'CREDIT_OPTIMIZER_CONTAINER',
  ACADEMY_ARTICLES_CONTAINER: 'ACADEMY_ARTICLES_CONTAINER',
  APPLY_IN_THREE_STEPS_CONTAINER: 'APPLY_IN_THREE_STEPS_CONTAINER',
  APPLY_IN_THREE_STEPS_CONTAINER_CONTEST:
    'APPLY_IN_THREE_STEPS_CONTAINER_CONTEST',
  AUTO_LOANS_CONTAINER: 'AUTO_LOANS_CONTAINER',
  BENEFITS_OF_LOAN_PROTECTION_PLAN_CONTAINER:
    'BENEFITS_OF_LOAN_PROTECTION_PLAN_CONTAINER',
  BOYS_AND_GIRLS_CLUB_CONTAINER: 'BOYS_AND_GIRLS_CLUB_CONTAINER',
  BRANCH_LOCATOR_CONTAINER: 'BRANCH_LOCATOR_CONTAINER',
  BRANCH_LOCATOR_CONTACT_US_CONTAINER: 'BRANCH_LOCATOR_CONTACT_US_CONTAINER',
  BREADCRUMBS_CONTAINER: 'BREADCRUMBS_CONTAINER',
  CITY_LOAN_SERVICES_CONTAINER: 'CITY_LOAN_SERVICES_CONTAINER',
  CITY_VALUE_PROPOSITION_CONTAINER: 'CITY_VALUE_PROPOSITION_CONTAINER',
  CLAIMS_CONTENT_SECTION_CONTAINER: 'CLAIMS_CONTENT_SECTION_CONTAINER',
  CONTACT_US_TILES_CONTAINER: 'CONTACT_US_TILES_CONTAINER',
  CONTENT_AND_CARDS_CONTAINER: 'CONTENT_AND_CARDS_CONTAINER',
  CONTENT_AND_CAROUSEL_CONTAINER: 'CONTENT_AND_CAROUSEL_CONTAINER',
  CONTENT_AND_VIDEO_CONTAINER: 'CONTENT_AND_VIDEO_CONTAINER',
  DOCUMENT_LIST_CONTAINER: 'DOCUMENT_LIST_CONTAINER',
  FEEFO_REVIEWS_CONTAINER: 'FEEFO_REVIEWS_CONTAINER',
  FINANCIAL_EDUCATION_CONTAINER: 'FINANCIAL_EDUCATION_CONTAINER',
  FIND_BRANCH_CONTACT_US_CONTAINER: 'FIND_BRANCH_CONTACT_US_CONTAINER',
  FIND_BRANCH_HEADER_CONTAINER: 'FIND_BRANCH_HEADER_CONTAINER',
  FOUR_CARDS_ROW_CONTAINER: 'FOUR_CARDS_ROW_CONTAINER',
  GOT_YOU_COVERED_CONTAINER: 'GOT_YOU_COVERED_CONTAINER',
  HERO_BANNER_CONTAINER: 'HERO_BANNER_CONTAINER',
  HOME_AND_AUTO_BENEFIT_PLAN_CONTAINER: 'HOME_AND_AUTO_BENEFIT_PLAN_CONTAINER',
  HUMANITY_FOR_COMMUNITY_CONTAINER: 'HUMANITY_FOR_COMMUNITY_CONTAINER',
  IMAGE_WITH_POINTS_CONTAINER: 'IMAGE_WITH_POINTS_CONTAINER',
  INFO_AND_IMAGE_CONTAINER: 'INFO_AND_IMAGE_CONTAINER',
  LEND_CARE_CONTAINER: 'LEND_CARE_CONTAINER',
  LOAN_PRODUCT_CONTAINER: 'LOAN_PRODUCT_CONTAINER',
  LOAN_PROTECTION_PLAN_CONTAINER: 'LOAN_PROTECTION_PLAN_CONTAINER',
  LOGO_TITLE_CONTAINER: 'LOGO_TITLE_CONTAINER',
  LPP_CLAIM_CONTAINER: 'LPP_CLAIM_CONTAINER',
  CONTACT_US_LPP_CLAIM_CONTAINER: 'CONTACT_US_LPP_CLAIM_CONTAINER',
  OUR_PARTNERS_CONTAINER: 'OUR_PARTNERS_CONTAINER',
  OUR_SERVICES_CONTAINER: 'OUR_SERVICES_CONTAINER',
  STEPS_AND_IMAGE_CONTAINER: 'STEPS_AND_IMAGE_CONTAINER',
  STEPS_TO_FILE_CONTAINER: 'STEPS_TO_FILE_CONTAINER',
  SUPPORT_COMMUNITY_CONTAINER: 'SUPPORT_COMMUNITY_CONTAINER',
  TESTIMONIAL_WITH_STATS_CONTAINER: 'TESTIMONIAL_WITH_STATS_CONTAINER',
  THREE_CARDS_ROW_CONTAINER: 'THREE_CARDS_ROW_CONTAINER',
  VALUE_ADDED_SERVICES_LPP_CONTAINER: 'VALUE_ADDED_SERVICES_LPP_CONTAINER',
  VALUE_PROPOSITION_CONTAINER: 'VALUE_PROPOSITION_CONTAINER',
  VIDEO_OVERLAY_CONTAINER: 'VIDEO_OVERLAY_CONTAINER',
  WHATS_INCLUDED_CONTAINER: 'WHATS_INCLUDED_CONTAINER',
  HEADER_CONTAINER: 'HEADER_CONTAINER',
  HEADER_PROVINCE_SELECTION: 'HEADER_PROVINCE_SELECTION',
  POS_EMAIL_US_CONTAINER: 'POS_EMAIL_US_CONTAINER',
  NOT_FOUND_PAGE: 'NOT_FOUND_PAGE',
  FINANCIAL_EDUCATION_CONTAINER_VERSION_TWO : 'FINANCIAL_EDUCATION_CONTAINER_VERSION_TWO',
  APPLY_IN_THREE_STEPS_CONTAINER_VERSION_TWO: 'APPLY_IN_THREE_STEPS_CONTAINER_VERSION_TWO',
  HOME_FEATURED: 'HOME_FEATURED',
  APPLY_IN_THREE_STEPS_CONTAINER_LOAN_PRODUCTS: 'APPLY_IN_THREE_STEPS_CONTAINER_LOAN_PRODUCTS',
  LOAN_PRODUCTS_PERSONAL_LOAN_BENEFITS_CONTAINER: 'LOAN_PRODUCTS_PERSONAL_LOAN_BENEFITS_CONTAINER',
  LOAN_PRODUCTS_PAYMENT_CALCULATOR_CONTAINER: 'LOAN_PRODUCTS_PAYMENT_CALCULATOR_CONTAINER',
  GET_INTOUCH_CONTAINER: 'GET_INTOUCH_CONTAINER',
  TABS_AND_ACCORDION:'TABS_AND_ACCORDION',
  CIRCLE_IMAGES_CAPTION_CONTAINER: 'CIRCLE_IMAGES_CAPTION_CONTAINER',
  LOGO_TITLE_CONTAINER: 'LOGO_TITLE_CONTAINER',
  PERSONAL_LOAN_BENEFITS_MERCHANT_CONTAINER : 'PERSONAL_LOAN_BENEFITS_MERCHANT_CONTAINER',
  HERO_BANNER_VARIATION_PERSONAL_LOANS: 'HERO_BANNER_VARIATION_PERSONAL_LOANS',
  NOT_FOUND_CONTAINER : 'NOT_FOUND_CONTAINER',
  SEARCH_CONTAINER: 'SEARCH_CONTAINER',
  IMAGE_AND_CONTENT_CONTAINER : 'IMAGE_AND_CONTENT_CONTAINER',
  TYPOGRAPHY_HEADING_CONTAINER: 'TYPOGRAPHY_HEADING_CONTAINER',
  TEXT_BAR_CONTAINER: 'TEXT_BAR_CONTAINER',
  FIND_BRANCH_SEARCH_CONTAINER: 'FIND_BRANCH_SEARCH_CONTAINER',
  HERO_BANNER_DIFFERENCE_CONTAINER: 'HERO_BANNER_DIFFERENCE_CONTAINER',
  IMAGE_HERO_BANNER: 'IMAGE_HERO_BANNER',
  BUDGET_CALCULATOR: 'BUDGET_CALCULATOR',
  SUBSCRIPTION_EMAIL_CONTAINER: 'SUBSCRIPTION_EMAIL_CONTAINER',
  ASSETS_CONTAINER: 'ASSETS_CONTAINER',
  SWAT_MAIL_SUBSCRIPTION: 'SWAT_MAIL_SUBSCRIPTION',
  MAIL_OFFER_SUBSCRIPTION: 'MAIL_OFFER_SUBSCRIPTION',
  MAIL_OFFER_GIFT_CARD: 'MAIL_OFFER_GIFT_CARD',
  OUTAGE_PAGE_CONTAINER: 'OUTAGE_PAGE_CONTAINER',
  AFFILIATES_CONTAINER: 'AFFILIATES_CONTAINER',
  EASYCARD_BUILD_CREDIT: 'EASYCARD_BUILD_CREDIT',
  EASYCARD_KEY_BENEFITS: 'EASYCARD_KEY_BENEFITS',
  EASYCARD_SECURITY_PROTECTION: 'EASYCARD_SECURITY_PROTECTION',
  MANAGE_YOUR_ACCOUNT:  'MANAGE_YOUR_ACCOUNT',
  CCA_LEGAL_CONTAINER: 'CCA_LEGAL_CONTAINER',
  ACCESS_EASY_CARD: 'ACCESS_EASY_CARD',
  EASYCARD_ACCESS_EASY_CARD: 'EASYCARD_ACCESS_EASY_CARD',
  EASYCARD_FAQ_CONTAINER: 'EASYCARD_FAQ_CONTAINER',
};
/* FEEFO URLS */

export const IS_SHOW_NAMES = {
  EMAIL_US: 'Email Us',
  LIVE_CHAT: 'Live chat',
  CALL_US: 'Call Us',
};

export const FEEFO_URLS = {
  LOGO:
    'https://api.feefo.com/api/logo?merchantidentifier=easy-financial&template=Service-Stars-White-175x44.png&since=all',
  EN:
    'https://www.feefo.com/en-GB/reviews/easy-financial?displayFeedbackType=SERVICE&timeFrame=YEAR',
  FR:
    'https://www.feefo.com/fr-FR/reviews/easy-financial?displayFeedbackType=SERVICE&timeFrame=YEAR',
};
export const APPLICATION_INSIGHTS_ROLE_NAME = 'easyfinancial-fe';

export const BUTTON_TYPES = {
  LINK: 'LINK',
};

export const MESSAGES = {
  SUCCESS: 'success',
  ERROR: 'error',
};
